import script from "./InsertionCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./InsertionCard.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__